import { render, staticRenderFns } from "./job-position-card.vue?vue&type=template&id=26515358&scoped=true&"
import script from "./job-position-card.vue?vue&type=script&lang=js&"
export * from "./job-position-card.vue?vue&type=script&lang=js&"
import style0 from "./job-position-card.vue?vue&type=style&index=0&id=26515358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26515358",
  null
  
)

export default component.exports